/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import {ChangeDetectionStrategy, Component, HostBinding} from '@angular/core';
import {SpacerBlock} from '../../classes/Elements';
import {createWidthHeight} from '../../utils';

import {AbstractBlock} from '../abstract-block';

@Component({
  selector: 'ip-spacer',
  template: '',
  styles: [
    `
      :host {
        display: table;
        width: 100%;
        transition: all 500ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
      }
    `
  ],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpacerComponent extends AbstractBlock<SpacerBlock> {
  // @Input() block: SpacerBlock = new SpacerBlock();

  @HostBinding('style.height') get height() {
    return createWidthHeight(this.block.options.height);
  }
}
